import { SignIn } from '@clerk/react';

export default function Login() {
  return (
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '60px' }}>
      <SignIn 
        path="/login" 
        routing="path" 
        signUpUrl="/join" 
        afterSignInUrl="/"
      />
    </div>
  );
}